<script>
import RawData from "@/components/widgets/raw-data.vue";
import LoadingTemplate from "@/components/widgets/loading-template.vue";
export default {
    name: "JournalEntries",
    components: {
        RawData,
        LoadingTemplate
    },
    props: {
        entries: {
            type: Array,
            default: () => [],
        },
        statusType: {
            type: String,
            default: "draft", // draft or posted
        },
        type: {
            type: String,
            default: "jev",
        },
        loading: {
            type: Boolean,
            default: false,
        },
        selection: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            filter: "",
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
        };
    },
    computed: {
        filtered() {
            let data = this.entries;
            if (this.filter && this.filter.trim() != "") {
                data = data.filter((item) => {
                    return item.filterKey
                        .toLowerCase()
                        .includes(this.filter.toLowerCase());
                });
            }
            var total = this.currentPage * this.perPage;
            var currentData = data.slice(total - this.perPage, total);
            if (this.currentPage > 1 && currentData.length == 0) {
                total = (this.currentPage - 1) * this.perPage;
                currentData = data.slice(total - this.perPage, total);
            }
            return currentData;
        },
        rows() {
            let data = this.entries;
            if (this.filter && this.filter.trim() != "") {
                data = data.filter((item) => {
                    return item.filterKey
                        .toLowerCase()
                        .includes(this.filter.toLowerCase());
                });
            }
            return data.length;
        },
        selectedEntries() {
            return this.entries.filter(item => item.selected);
        }
    },
    methods: {
        addJEVEntry() {
            this.$emit("add-entry");
        },
        getJevDetails(item) {
            item.opened = !item.opened;
        },
        formatText(text) {
            return text.replace(/(?:\r\n|\r|\n)/g, "<br>");
        },
        editJevEntry(item) {
            this.$emit("edit-entry", item);
        },
        deleteJevEntry(item) {
            this.$emit("delete-entry", item);
        },
        printJev(item) {
            this.$emit("print-jev", item);
        },
        getTotalDebit(items) {
            return items.reduce((total, item) => {
                return total + (item.debit || 0);
            }, 0);
        },
        getTotalCredit(items) {
            return items.reduce((total, item) => {
                return total + (item.credit || 0);
            }, 0);
        },
        postJevEntry(item) {
            this.$emit("post-entry", item);
        },
        approveJevEntry(item) {
            this.$emit("approveJevEntry", item);
        },
        getSL(detail) {
            if (detail.subsidiaryLedgerObj) return;
            this.$set(detail, 'subsidiaryLedgerObj', null);
            this.$store.dispatch('subsidiaryledger/getSingleSubsidiaryLedger', detail.subsidiaryLedgerId)
                .then(res => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, 'error');
                    }
                    this.$set(detail, 'subsidiaryLedgerObj', res.data);
                })
                .catch(err => {
                    this.showToast('Something went wrong while fetching Subsidiary Ledger!', 'error');
                });
        },
        async postNow(form, jev){
            await this.$store.dispatch('jev/postJev', {
                id: jev.id,
                jevNumber: form.jevNumber,
            })
            .then(res => {
                if (res.data.error) {
                    return this.showToast(res.data.errorMessage, 'error');
                }
                jev.isPosted = true;
                jev.jevNumber = form.jevNumber;
                this.showToast('Journal posted successfully!', 'success');
            })
            .catch(err => {
                this.showToast('Something went wrong while posting Journal!', 'error');
            });
        },
        getTypeName(type){
            switch(type.toLowerCase()){
                case 'jev': return 'Journal Entry';
                case 'dv': return 'Disbursement';
                case 'rcd': return 'Report of Collection & Deposit';
                default: return 'Journal Entry';
            }
        }
    }
}
</script>
<template>
    <div class="jev-entries">
        <div class="card">
            <div class="card-body bg-soft" :class="{'bg-primary': statusType === 'pending', 'bg-success': statusType === 'posted'}">
                <div
                    class="
                        d-flex
                        justify-content-between
                        align-items-center
                        mb-3
                    "
                >
                    <div>
                        <h4 class="card-title mb-0">
                            {{type}}
                        </h4>
                        <p class="card-title-desc mb-0">
                            List of {{type}}(s)
                        </p>
                    </div>
                    <div v-if="entries.length > 0">
                        <div class="d-flex">
                            <input
                                autocomplete="off"
                                type="text"
                                v-model="filter"
                                placeholder="Search Journals..."
                                class="form-control"
                            />
                            <b-form-select
                                class="form-select ms-1 w-25"
                                v-model="perPage"
                                :options="pageOptions"
                            ></b-form-select>
                        </div>
                    </div>
                </div>
                <div v-if="loading" class="text-center my-5 py-5">
                    <LoadingTemplate class="my-5"/>
                </div>
                <div v-if="!loading && entries.length == 0" class="text-center">
                    <h5>No data available</h5>
                </div>
                <div v-if="!loading && entries.length && !filtered.length" class="text-center">
                    <h5>Search not found</h5>
                </div>
                <template v-if="entries.length > 0">
                    <div
                        role="tablist"
                        v-for="(x, index) in filtered"
                        :key="x.id"
                    >
                        <b-card
                            no-body
                            class="mb-1 shadow-none"
                            :style="{'z-index': `${filtered.length - index}`}"
                        >
                            <RawData :data="x" v-if="$store.state.decrypt.isAdmin()" placement="left"/>
                            <b-card-header
                                header-tag="header"
                                role="tab"
                                header-class="cursor-pointer"
                                @click="getJevDetails(x)"
                            >
                                <div
                                    class="
                                        d-flex
                                        justify-content-between
                                        align-items-center
                                    "
                                >
                                    <h6 class="m-0">
                                        <a class="text-dark" href="javascript: void(0);">
                                            &nbsp;
                                            <!-- <span class="text-warning">[{{ x.jevNumber}}]</span> -->
                                            <!-- :&nbsp; -->
                                            {{ x.description }}
                                        </a>
                                    </h6>
                                    <div class="d-flex align-items-center">
                                        <div>
                                            <span class="d-flex align-items-center text-truncate">
                                                <small v-if="!x.opened">Click here to expand</small>
                                                <i 
                                                    class="bx bx-chevron-right rotate font-size-18 ms-3"
                                                    :class="{'rotate-90': x.opened }"
                                                ></i
                                            ></span>
                                        </div>
                                    </div>
                                </div>
                            </b-card-header>
                            <b-collapse
                                :visible="x.opened"
                                :accordion="`jev-accordion-${statusType}-${x.id}`"
                                role="tabpanel"
                            >
                                <b-card-body>
                                    <div class="d-flex align-items-center justify-content-between cursor-pointer border-bottom pb-2 mb-2" >
                                        <h5 class="mb-0"><i class="bx bx-receipt"></i> Journal Details</h5>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-5 border-end">
                                            <table class="w-100">
                                                <tr>
                                                    <td class="px-2">Description:</td>
                                                    <td class="font-weight-bold text-white">{{x.description || '-'}}</td>
                                                </tr>
                                                <tr>
                                                    <td class="px-2">Journal Date:</td>
                                                    <td class="font-weight-bold text-white">{{x.journalDateTime ? formatDate(new Date(x.journalDateTime)) : '-'}}</td>
                                                </tr>
                                                <tr>
                                                    <td class="px-2">Fund Source:</td>
                                                    <td class="font-weight-bold text-white">{{x.fundSource || '-'}}</td>
                                                </tr>
                                                <tr>
                                                    <td class="px-2">Source Documents:</td>
                                                    <td class="font-weight-bold text-white">{{x.sourceDocument || '-'}}</td>
                                                </tr>
                                                <tr v-if="x.isPosted">
                                                    <td class="px-2">Posted By:</td>
                                                    <td class="font-weight-bold text-white">{{x.createdBy || '-'}}</td>
                                                </tr>
                                                <tr>
                                                    <td colspan="2" class="pt-3">
                                                        <button class="btn btn-outline-info btn-rounded btn-block" @click="$emit('view-details', x)">View {{getTypeName(x.referenceType)}} Details</button>
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                        <div class="col-md-7">
                                            <div class="d-flex align-items-end justify-content-between mb-1">
                                                <label for="journalEntryDetails" class="mb-0">Journal Details:</label>
                                                <div class="text-right font-size-16 ">
                                                    <div>Total Debit: <span class="text-success font-weight-bold">{{formatCurrency(getTotalDebit(x.journalEntryDetails || []))}}</span></div>
                                                    <div>Total Credit: <span class="text-warning font-weight-bold">{{formatCurrency(getTotalCredit(x.journalEntryDetails || []))}}</span></div>
                                                </div>
                                            </div>
                                            <div class="py-2 rounded mb-2">
                                                <table class="table table-sm align-middle table-bordered border-primary mb-0">
                                                    <thead>
                                                        <tr>
                                                            <th class="py-2">Account</th>
                                                            <th class="py-2 text-center" style="width:120px;">Debit</th>
                                                            <th class="py-2 text-center" style="width:120px;">Credit</th>
                                                            <th class="py-2 text-center">Subsidiary Ledger</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <template v-if="!x.journalEntryDetails || x.journalEntryDetails.length == 0">
                                                            <tr>
                                                                <td colspan="4" class="text-center">No journal details available</td>
                                                            </tr>
                                                        </template>
                                                        <tr v-for="(detail, detailIndex) in x.journalEntryDetails" :key="detailIndex">
                                                            <td class="py-2">
                                                                <div class="position-relative">
                                                                    <RawData :data="detail" v-if="$store.state.decrypt.isAdmin()" />
                                                                    {{detail.account}}
                                                                </div>
                                                            </td>
                                                            <td class="py-2 text-center">{{detail.debit ? formatCurrency(detail.debit) : '-'}}</td>
                                                            <td class="py-2 text-center">{{detail.credit ? formatCurrency(detail.credit) : '-'}}</td>
                                                            <!-- <td class="py-2 text-center">
                                                                <span v-if="detail.isSundry" class="badge bg-info">Yes</span>
                                                                <span v-else class="badge bg-secondary">No</span>
                                                            </td> -->
                                                            <td  class="py-2 text-center">
                                                                <template v-if="!detail.subsidiaryLedgerId">
                                                                    -
                                                                </template>
                                                                <template v-else>
                                                                    <a href="javascript:void(0);" class="font-size-14 mb-0" :id="`A-${detailIndex}`" @click="getSL(detail)">{{ detail.subsidiaryLedgerId ? detail.subsidiaryLedger : '-' }}</a>
                                                                    <b-popover :target="`A-${detailIndex}`" placement="left" triggers="click blur">
                                                                        <template #title>Subsidiary Ledger</template>
                                                                        <div>
                                                                            <div v-if="!detail.subsidiaryLedgerObj" class="text-center">
                                                                                <b-spinner small></b-spinner>
                                                                                <small class="d-block mt-1">Loading...</small>
                                                                            </div>
                                                                            <div v-else>
                                                                                <div class="text-truncate">{{ detail.subsidiaryLedgerObj.code }}</div>
                                                                                <div class="font-size-13 text-success font-weight-bold">{{ detail.subsidiaryLedgerObj.clientDto.name }}</div>
                                                                                <div>{{ detail.subsidiaryLedgerObj.subsidiaryLedgerType }}</div>
                                                                            </div>
                                                                        </div>
                                                                    </b-popover>
                                                                </template>
                                                            </td>
                                                        </tr>
                                                        <tr class="table-secondary font-weight-bold">
                                                            <td class="py-2">Total</td>
                                                            <td class="py-2 text-center">{{ formatCurrency(getTotalDebit(x.journalEntryDetails || [])) }}</td>
                                                            <td class="py-2 text-center">{{ formatCurrency(getTotalCredit(x.journalEntryDetails || [])) }}</td>
                                                            <td class="py-2"></td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="d-flex justify-content-end gap-1 border-top pt-3 mt-2" v-if="statusType === 'pending'">
                                        <button type="button" class="btn btn-outline-info btn-rounded" @click="editJevEntry(x)">
                                            <i class="bx bx-edit"></i> Edit Journal
                                        </button>
                                        <button type="button" class="btn btn-outline-danger btn-rounded" @click="deleteJevEntry(x)">
                                            <i class="bx bx-trash"></i> Delete Journal
                                        </button>
                                        <button 
                                            type="button" 
                                            class="btn btn-outline-warning btn-rounded" 
                                            @click="$emit('attachment', {att: ['po', 'rfp', 'burs', 'dv', 'jev', 'journal'], id: x.id})"
                                        >
                                            <i class="bx bx-paperclip rotate rotate-45"></i> Attachments
                                        </button>
                                        <!-- <button type="button" class="btn btn-outline-purple btn-rounded" @click="printJev(x)">
                                            <i class="bx bx-printer"></i> Print Journal Entry
                                        </button> -->
                                        <button 
                                            type="button" 
                                            class="btn btn-outline-success btn-rounded" 
                                            @click="postJevEntry(x)"
                                        >
                                            <i class="bx bx-check"></i> Post Journal
                                        </button>
                                        <!-- <button 
                                            type="button" 
                                            class="btn btn-outline-primary btn-rounded" 
                                            @click="approveJevEntry(x)"
                                            v-if="type === 'posted'"
                                        >
                                            <i class="bx bx-check-double"></i> Approve Journal Entry
                                        </button> -->
                                    </div>
                                </b-card-body>
                            </b-collapse>
                        </b-card>
                    </div>
                </template>
            </div>
        </div>
        <div class="d-flex justify-content-between align-items-center mb-2">
            <div class="d-flex gap-2">
                <button 
                    v-if="selection && selectedEntries.length" 
                    type="button" 
                    class="btn btn-success" 
                    @click="$emit('bulkPost', selectedEntries)"
                >
                    <i class="bx bx-receipt"></i> Post Selected ({{selectedEntries.length}})
                </button>
            </div>
        </div>
        <div class="d-flex justify-content-end mt-2" v-if="entries.length">
            <div class="dataTables_paginate paging_simple_numbers">
                <ul class="pagination pagination-rounded mb-0">
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                    ></b-pagination>
                </ul>
            </div>
        </div>
    </div>
</template>

<style scoped>
.hoverable-link:hover {
    text-decoration: underline;
}

.hover-header:hover {
    background-color: rgba(255, 255, 255, 0.05);
}

.rotate {
    transition: transform 0.3s ease;
}

.rotate-90 {
    transform: rotate(90deg);
}

.rotate-45 {
    transform: rotate(45deg);
}
</style>